// src/modules/app-views/_apps/applekkus/landingPages/pages/Init/components/tableColumns/nameColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function nameColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'landing_page',
    dataIndex = 'name',
    width,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => (
      <div className="d-flex flex-column" style={{ width }}>
        <span className="font-weight-semibold">{r?.name || '—'}</span>
        {r?.url && (
          <span className="text-muted font-size-sm" style={{ fontSize: 11, textTransform: 'lowercase' }}>
            {r.url}
          </span>
        )}
      </div>
    ),
  };
}

export default nameColumn;
